var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMore2Line = function SvgMore2Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.5 3.898c-.742 0-1.35.608-1.35 1.35s.607 1.35 1.35 1.35c.742 0 1.35-.607 1.35-1.35 0-.742-.607-1.35-1.35-1.35m0 13.5c-.742 0-1.35.608-1.35 1.35s.607 1.35 1.35 1.35c.742 0 1.35-.607 1.35-1.35 0-.742-.607-1.35-1.35-1.35m0-6.75c-.742 0-1.35.608-1.35 1.35s.607 1.35 1.35 1.35c.742 0 1.35-.607 1.35-1.35 0-.742-.607-1.35-1.35-1.35"
  })));
};
export default SvgMore2Line;